/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import Config from '../app/Config.json'

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

const TENANT_ID = '987179e8-1c49-493a-88e8-06d464695b5c'
const CLIENT_ID = 'd8e15a9b-0c2d-4976-b0e5-73f91d5d3794'

export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: Config.AUTH_REDIRECT_URL,
        postLogoutRedirectUri: `${Config.AUTH_REDIRECT_URL}/login`
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [`api://${CLIENT_ID}/liDARnetics/CustomScope`]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

export const requiredGroups = [
    'bb908d38-c4af-48d2-a2be-a6309bd9a11e', //AAM-Lidarnetics-Users
]

export const guestGroups = [
    'c634ff4a-66ff-4b2d-8c63-e9832d490858' //Guest Users_Cybersecurity
]

export const managerGroup = [
    '0e63a835-f158-4062-9593-da2691df8543' //AAM-Lidarnetics-Managers
]

export const africaUserGroup = [
    'TBD' //Africa-Lidarnetics-Users
]

export const africaManagerGroup = [
    'TBD' //Africa-Lidarnetics-Managers
]